var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96826 7.21191C7.96826 7.30469 7.94873 7.39258 7.90967 7.47559C7.87549 7.55371 7.82422 7.62695 7.75586 7.69531L1.95508 13.3716C1.82324 13.5034 1.66211 13.5693 1.47168 13.5693C1.34961 13.5693 1.2373 13.54 1.13477 13.4814C1.03223 13.4229 0.95166 13.3423 0.893066 13.2397C0.834473 13.1421 0.805176 13.0298 0.805176 12.9028C0.805176 12.7222 0.868652 12.5635 0.995605 12.4268L6.32764 7.21191L0.995605 1.99707C0.868652 1.86035 0.805176 1.70166 0.805176 1.521C0.805176 1.39404 0.834473 1.28174 0.893066 1.18408C0.95166 1.08154 1.03223 1.00098 1.13477 0.942383C1.2373 0.883789 1.34961 0.854492 1.47168 0.854492C1.66211 0.854492 1.82324 0.917969 1.95508 1.04492L7.75586 6.72852C7.82422 6.79688 7.87549 6.87256 7.90967 6.95557C7.94873 7.03369 7.96826 7.11914 7.96826 7.21191Z",
    fill: "#AEAEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGrey);
export default __webpack_public_path__ + "static/media/arrow-right-grey.68f7af849eee80d5df16c44b155d2ee2.svg";
export { ForwardRef as ReactComponent };